module.exports = __webpack_public_path__ + "static/media/22ESCWA4.abb468e0.jpg";